<template>
  <div class="social">
      <div v-for="(item, index) in media" :key="index">
        <a :href="item.link" target="_blank">
          <icon :description="item.icon" size="28" />
        </a>
      </div>
    </div>
</template>

<script>
export default {
  name: 'social-media',
  data() {
    return {
      media: [
        {
          id: 1,
          link: 'https://fb.me/representegestao/',
          icon: 'rep-social-facebook',
        },
        {
          id: 2,
          icon: 'rep-social-instagram',
          link: 'https://www.instagram.com/representegestao/',
        },
        {
          id: 3,
          icon: 'rep-social-linkedin',
          link: 'https://linkedin.com/company/represente-gestao/',
        },
        {
          id: 4,
          icon: 'rep-social-whatsapp',
          link: 'https://api.whatsapp.com/send?phone=5531982669088',
        },
      ],
    };
  },
};
</script>

<style lang="sass" scoped>
  @import "../assets/sass/main.sass"
  .social
    display: flex
    flex-wrap: nowrap
    justify-content: space-between
    margin: 12px 0
    svg
      fill: $grey-800
    @media (max-width: $widthTerciary)
      width: 70%
      margin: 18px auto 0
</style>
